import { render, staticRenderFns } from "./TableAvatar.vue?vue&type=template&id=236baf06&scoped=true"
import script from "./TableAvatar.vue?vue&type=script&lang=ts"
export * from "./TableAvatar.vue?vue&type=script&lang=ts"
import style0 from "./TableAvatar.vue?vue&type=style&index=0&id=236baf06&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236baf06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('236baf06')) {
      api.createRecord('236baf06', component.options)
    } else {
      api.reload('236baf06', component.options)
    }
    module.hot.accept("./TableAvatar.vue?vue&type=template&id=236baf06&scoped=true", function () {
      api.rerender('236baf06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/TableAvatar.vue"
export default component.exports